import React, { useEffect, useMemo } from "react";

const move = (arr, i, d) => {
  const j = i + d;
  if (j < 0 || j >= arr.length) return arr;
  const c = [...arr];
  [c[i], c[j]] = [c[j], c[i]];
  return c;
};

const tile = { position: "relative", width: 118, border: "1px solid #dbe3ea", borderRadius: 8, padding: 6, background: "#fff", textAlign: "center" };
const thumb = { width: "100%", height: 80, objectFit: "cover", borderRadius: 6, display: "block" };
const btn = { border: "1px solid #dbe3ea", background: "#f4f7fa", borderRadius: 5, padding: "1px 7px", fontSize: 13, lineHeight: "20px", cursor: "pointer" };
const cover = { position: "absolute", top: 8, left: 8, background: "#14283a", color: "#fff", fontSize: 11, padding: "1px 7px", borderRadius: 99 };


const ImpactImages = ({ existing = [], setExisting, removeIds = [], setRemoveIds, files, setFiles, base = "" }) => {
  const urls = useMemo(() => files.map((f) => URL.createObjectURL(f)), [files]);
  useEffect(() => () => urls.forEach((u) => URL.revokeObjectURL(u)), [urls]);

  const live = existing.filter((e) => !removeIds.includes(e.id));
  const coverKey = live.length ? `e${live[0].id}` : files.length ? "n0" : "";

  const pick = (e) => {
    const picked = Array.from(e.target.files || []).filter((f) => f.type.startsWith("image/"));
    if (picked.length) setFiles((old) => [...old, ...picked]);
    e.target.value = ""; // the same file can be picked again
  };

  const toggle = (id) => setRemoveIds((r) => (r.includes(id) ? r.filter((x) => x !== id) : [...r, id]));

  return (
    <div>
      <input type="file" accept="image/*" multiple className="form-control w-100" onChange={pick} />
      <small className="text-muted d-block mt-1">
        Pick one or more images (you can pick again to add more). The first image is the thumbnail on the website; use the arrows to
        change the order.{existing.length > 0 && " New images are added after the saved ones."}
      </small>

      {(existing.length > 0 || files.length > 0) && (
        <div className="d-flex flex-wrap gap-2 mt-3">
          {existing.map((im, i) => {
            const removed = removeIds.includes(im.id);
            return (
              <div key={`e${im.id}`} style={{ ...tile, opacity: removed ? 0.4 : 1 }}>
                {coverKey === `e${im.id}` && <span style={cover}>Thumbnail</span>}
                <img src={base + im.image} alt="" style={thumb} />
                <div className="d-flex justify-content-center gap-1 mt-1">
                  {!removed && (
                    <>
                      <button type="button" style={btn} onClick={() => setExisting((a) => move(a, i, -1))} aria-label="Move earlier">‹</button>
                      <button type="button" style={btn} onClick={() => setExisting((a) => move(a, i, 1))} aria-label="Move later">›</button>
                    </>
                  )}
                  <button type="button" style={{ ...btn, color: removed ? "#14283a" : "#b3261e" }} onClick={() => toggle(im.id)}>
                    {removed ? "Undo" : "Remove"}
                  </button>
                </div>
              </div>
            );
          })}

          {files.map((f, i) => (
            <div key={`n${i}-${f.name}-${f.size}`} style={{ ...tile, borderStyle: "dashed" }}>
              {coverKey === `n${i}` && <span style={cover}>Thumbnail</span>}
              <img src={urls[i]} alt="" style={thumb} />
              <div className="d-flex justify-content-center gap-1 mt-1">
                <button type="button" style={btn} onClick={() => setFiles((a) => move(a, i, -1))} aria-label="Move earlier">‹</button>
                <button type="button" style={btn} onClick={() => setFiles((a) => move(a, i, 1))} aria-label="Move later">›</button>
                <button type="button" style={{ ...btn, color: "#b3261e" }} onClick={() => setFiles((a) => a.filter((_, k) => k !== i))}>✕</button>
              </div>
              <small className="text-muted">New</small>
            </div>
          ))}
        </div>
      )}
      {existing.some((e) => removeIds.includes(e.id)) && <small className="text-muted d-block mt-2">Removed images are deleted when you press Save.</small>}
    </div>
  );
};

export default ImpactImages;